import { render, staticRenderFns } from "./ShareEmail.vue?vue&type=template&id=4c30801e&"
import script from "./ShareEmail.vue?vue&type=script&lang=js&"
export * from "./ShareEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/rec-rich/lib/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c30801e')) {
      api.createRecord('4c30801e', component.options)
    } else {
      api.reload('4c30801e', component.options)
    }
    module.hot.accept("./ShareEmail.vue?vue&type=template&id=4c30801e&", function () {
      api.rerender('4c30801e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/main2/components/media/ShareEmail.vue"
export default component.exports